export * from "./ImagesTemplate";
